// extracted by mini-css-extract-plugin
module.exports = {"fichas":"Consultar_fichas__3rTF_"};